function preventSamePageNavigation(e: PointerEvent, el: HTMLAnchorElement) {
  if (!el.href) return;

  const currentUrl = new URL(window.location.href);
  const targetUrl = new URL(el.href, currentUrl);

  if (
    currentUrl.origin === targetUrl.origin &&
    currentUrl.pathname === targetUrl.pathname &&
    currentUrl.search === targetUrl.search
  ) {
    e.preventDefault();
  }
}

export { preventSamePageNavigation };
